import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import { actions } from '../../../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

const FilterTextSearch = () => {
    const dispatch = useDispatch();
    // bool to show text search section
    const searchActive = useSelector(state => state.toggle.isSidebarPracticeSearchOpen);

    const buttonTitle = 'Filter practices with search terms';

    const getButtonClasses = (isActive) => isActive ? 'text-light bg-primary' : 'text-primary bg-light';

    const buttonClasses = `rounded-circle ${getButtonClasses(searchActive)}`;

    const buttonHandler = () => dispatch(actions.toggle.toggleSidebarPracticeSearchOpen(!searchActive));

    const icon = useMemo(() => <FontAwesomeIcon icon={faSearch} />, []);

    return (
        <Button title={buttonTitle} className={buttonClasses} onClick={buttonHandler}>
            {icon}
        </Button>
    );
};

export default React.memo(FilterTextSearch);
